// @ts-nocheck
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const REVEAL_SELECTOR =
  "#main-content main > section:not(.scene-section), #main-content main > .content-section";

export function ScrollRevealMotion() {
  const { pathname } = useLocation();

  useEffect(() => {
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    if (reduceMotion || !("IntersectionObserver" in window)) return undefined;

    const observed = new WeakSet();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-scroll-visible");
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -9% 0px" },
    );

    const register = () => {
      document.querySelectorAll(REVEAL_SELECTOR).forEach((section) => {
        if (observed.has(section)) return;
        observed.add(section);
        section.classList.add("scroll-reveal-section");
        observer.observe(section);
      });
    };

    document.documentElement.classList.add("scroll-motion-ready");
    register();

    const root = document.getElementById("main-content");
    const mutations = root
      ? new MutationObserver(() => window.requestAnimationFrame(register))
      : null;
    mutations?.observe(root, { childList: true, subtree: true });

    return () => {
      mutations?.disconnect();
      observer.disconnect();
      document.documentElement.classList.remove("scroll-motion-ready");
    };
  }, [pathname]);

  return null;
}
